import posthog from "posthog-js"

export const onClientEntry = () => {
  const apiKey = process.env.GATSBY_POSTHOG_KEY
  const apiHost = process.env.GATSBY_POSTHOG_HOST || "https://eu.i.posthog.com"

  if (apiKey) {
    // Check Cookiebot consent for statistics cookies
    const hasConsent =
      typeof window.Cookiebot !== "undefined" &&
      window.Cookiebot.consent &&
      window.Cookiebot.consent.statistics

    posthog.init(apiKey, {
      api_host: apiHost,
      capture_pageview: false,
      persistence: hasConsent ? "localStorage" : "memory",
      opt_out_capturing_by_default: !hasConsent,
    })

    // Re-evaluate when consent changes
    window.addEventListener("CookiebotOnAccept", () => {
      if (window.Cookiebot.consent.statistics) {
        posthog.opt_in_capturing()
        posthog.set_config({ persistence: "localStorage" })
      }
    })

    window.addEventListener("CookiebotOnDecline", () => {
      posthog.opt_out_capturing()
    })
  }
}

export const onRouteUpdate = ({ location }) => {
  if (posthog.__loaded) {
    posthog.capture("$pageview", {
      $current_url: location.href,
    })
  }
}
